import React, { useEffect, useState } from "react";
import axios from "axios";
import { io } from "socket.io-client";

import {
  StatsWrap,
  StatCard,
  StatLabel,
  StatDot,
  DigitalCount,
} from "./SigninElements"; // adapte le chemin si LiveCounters n'est pas dans le même dossier

const pad = (n, size = 5) => String(Math.max(0, n)).padStart(size, "0");

export default function LiveCounters({ apiBaseUrl }) {
  const API = apiBaseUrl || "http://localhost:5002";

  const [counts, setCounts] = useState({ clients: 0, drivers: 0 });
  const [display, setDisplay] = useState({ clients: 0, drivers: 0 });

  const animateTo = (key, target) => {
    setDisplay((prev) => {
      const start = prev[key];
      if (start === target) return prev;

      const duration = 520;
      const steps = 22;
      const stepTime = Math.max(12, Math.floor(duration / steps));
      let i = 0;

      const timer = setInterval(() => {
        i += 1;
        const t = i / steps;
        const next = Math.round(start + (target - start) * t);
        setDisplay((p) => ({ ...p, [key]: next }));
        if (i >= steps) clearInterval(timer);
      }, stepTime);

      return prev;
    });
  };

  const applyStats = (stats) => {
    const next = {
      clients: stats?.clients || 0,
      drivers: stats?.drivers || 0,
    };

    setCounts(next);
    animateTo("clients", next.clients);
    animateTo("drivers", next.drivers);
  };

  useEffect(() => {
    let socket;

    const init = async () => {
      // 1) init via HTTP (si route existe)
      try {
        const res = await axios.get(`${API}/api/public/stats`);
        applyStats(res.data);
      } catch (_) {
        // route peut être absente au début, pas grave
      }

      // 2) live via socket
      socket = io(API, { transports: ["websocket"] });
      socket.on("stats:update", applyStats);
    };

    init();

    return () => {
      if (socket) socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API]);

  return (
    <StatsWrap>
      <StatCard>
        <StatLabel>
          <StatDot $tone="clients" />
          Clients inscrits
        </StatLabel>
        <DigitalCount>{pad(display.clients, 5)}</DigitalCount>
        {/* <StatSub>Total: {counts.clients}</StatSub> */}
      </StatCard>

      <StatCard>
        <StatLabel>
          <StatDot $tone="drivers" />
          Chauffeurs inscrits
        </StatLabel>
        <DigitalCount>{pad(display.drivers, 5)}</DigitalCount>
        {/* <StatSub>Total: {counts.drivers}</StatSub> */}
      </StatCard>
    </StatsWrap>
  );
}